import { useCallback, useRef, useState } from 'react';
import { updateCompanyCurrency } from 'services/Configuration/companyCurrenciesService';

export function useUpdateCompanyCurrency() {
  const [updatedCurrency, setUpdatedCurrency] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const updateCurrency = useCallback(async (id, data) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    setError(null);
    try {
      const result = await updateCompanyCurrency(id, data, controller.signal);
      setUpdatedCurrency(result);
      return result;
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { updatedCurrency, isLoading, error, updateCurrency };
}
